<template>
	<div>

		<form action="#">

			<div class="row">
				<div class="col-8  transition-fadeinup">

					<h1>GA code</h1>
					<p>Morbi eleifend felis eu erat pellentesque, a varius nibh pulvinar. Curabitur vel rhoncus lacus. In hac habitasse platea dictumst. </p>

					<ul class="form">
						<li class="size50">
							<label>Site Google Analytics ID</label>
							<input type="text" placeholder="UA-XXXXXXXX-X">
						</li>
					</ul>

				</div>
			</div>

			<p>&nbsp;</p>
			<p>&nbsp;</p>

			<div class="row">
				<div class="col-8  transition-fadeinup">

					<h1>GDPR, Do not track</h1>
					<p><i class="fa fa-exclamation-triangle"></i> Tony's description... Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi eleifend felis eu erat pellentesque, a varius nibh pulvinar. Curabitur vel rhoncus lacus. In hac habitasse platea dictumst. </p>

					<ul class="form">
						<li>
							<label> <input type="checkbox" class="toggle"> Enable 'Do not track' scripts</label>
						</li>
					</ul>

				</div>
			</div>

			<div class="btns-top">
				<button type="submit" class="btn btn-submit transition-fadeinup transition-delay-02 fa fa-save"></button>
			</div>

		</form>

	</div>

</template>

<script>

export default {
	name: 'google-analytics'
}
</script>
